import type { ReactNode } from "react";

type Split =
  | "20/80"
  | "25/75"
  | "30/70"
  | "40/60"
  | "50/50"
  | "60/40"
  | "70/30"
  | "75/25"
  | "80/20";

interface SplitColumnsProps {
  left: ReactNode;
  right: ReactNode;
  /** Width ratio between left and right columns. Defaults to "50/50". */
  split?: Split;
}

const leftClasses: Record<Split, string> = {
  "20/80": "w-1/5",
  "25/75": "w-1/4",
  "30/70": "w-3/10",
  "40/60": "w-2/5",
  "50/50": "w-1/2",
  "60/40": "w-3/5",
  "70/30": "w-7/10",
  "75/25": "w-3/4",
  "80/20": "w-4/5",
};

export function SplitColumns({
  left,
  right,
  split = "50/50",
}: SplitColumnsProps) {
  return (
    <div className="flex h-full gap-6">
      <div className={`flex shrink-0 flex-col ${leftClasses[split]}`}>
        {left}
      </div>
      <div className="flex min-h-0 flex-1 flex-col">{right}</div>
    </div>
  );
}
